export default __webpack_public_path__ + "static/card-mymove-b39b9636fe3c413e351ef91685701a83.png";